export default {"src":"/_next/static/media/STLA.e5aebe05.svg","height":18,"width":18};